import { Dialog } from '@mui/material'
import { Stack } from '@mui/system'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import CheckCircle from 'assets/icons/check-circle.svg'
import { LogoButton } from 'components/common/Button/LogoButton'
import { GreyText } from 'components/common/common.style'
import {
  CloseAbsoluteDiv,
  CloseIconContainer,
  LogoContainer,
  ModalBody,
  TitleText
} from './AuthModal.style'
import { AuthModalContext } from './AuthModalContext'

export const ForgotPasswordSuccessModal = () => {
  const {
    modalParams: { state, email },
    setModalParams
  } = useContext(AuthModalContext)

  const onClose = () =>
    setModalParams({
      state: 'CLOSED',
      redirectUrl: '',
      email: '',
      sponsors: undefined
    })

  const { t } = useTranslation('authentication')

  return (
    <Dialog
      fullWidth
      sx={{
        '.MuiPaper-root': {
          width: '416px',
          height: 'auto'
        }
      }}
      open={state === 'FORGOT_PASSWORD_SUCCESS'}
      onClose={onClose}
    >
      <ModalBody>
        <Stack spacing={2} alignItems="center">
          <LogoContainer>
            <CheckCircle />
          </LogoContainer>
          <TitleText>{t('forgotPasswordSuccess.title')}</TitleText>
          <GreyText
            css={{
              textAlign: 'center'
            }}
          >
            {t('forgotPasswordSuccess.description', { email })}
          </GreyText>
        </Stack>
        <CloseAbsoluteDiv>
          <LogoButton
            onClick={onClose}
            icon={<CloseIconContainer />}
            noBorder
          />
        </CloseAbsoluteDiv>
      </ModalBody>
    </Dialog>
  )
}
